import { render, staticRenderFns } from "./CollageCustomOverlays.vue?vue&type=template&id=17ced33d&scoped=true&"
import script from "./CollageCustomOverlays.vue?vue&type=script&lang=js&"
export * from "./CollageCustomOverlays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ced33d",
  null
  
)

export default component.exports